import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Reveal } from '../components/Reveal';
import { EndNote } from '../components/EndNote';
import { projects } from '../data/projects';
import { ProjectGrid } from '../components/ProjectGrid';
export function Work() {
  const [searchParams, setSearchParams] = useSearchParams();
  const disciplines = useMemo(() => ['All', ...Array.from(new Set(projects.map(p => p.discipline)))], []);
  const requested = searchParams.get('category');
  const filter = requested && disciplines.includes(requested) ? requested : 'All';
  function setFilter(next: string) {
    if (next === 'All') {
      setSearchParams({});
    } else {
      setSearchParams({
        category: next
      });
    }
  }
  const visible = useMemo(() => filter === 'All' ? projects : projects.filter(project => project.discipline === filter), [filter]);
  return <div data-id="element-184" data-mp="ji4sqeogd6pi">
      <header className="mx-auto max-w-page px-6 pb-8 pt-14 md:px-10 md:pb-12 md:pt-24" data-id="element-185" data-mp="jiwopqlyp6gb">
        <h1 className="font-display text-4xl font-bold uppercase leading-[0.9] md:text-7xl" data-id="element-186" data-mp="3i9v7cqg2b6xh">
          The <span className="text-lilac" data-id="element-187" data-mp="3e9utp80sezrh">Work</span>
        </h1>
        <p className="mt-6 max-w-md text-sm leading-relaxed text-muted" data-id="element-188" data-mp="3rzog7jotl7y1">
          Pop-ups, national tours, conferences and tradeshows — built, trucked and run by us.
        </p>
      </header>

      <div className="mx-auto max-w-page px-6 pb-12 md:px-10 md:pb-16" data-id="element-189" data-mp="5rf58sfnl6ro">
        <div role="group" aria-label="Filter projects by discipline" className="flex flex-wrap items-center gap-x-6 gap-y-2 border-b border-line pb-5" data-id="element-190" data-mp="t3tud9pmo7c">
          {disciplines.map(discipline => {
          const active = discipline === filter;
          return <button key={discipline} type="button" onClick={() => setFilter(discipline)} aria-pressed={active} className={`text-[0.65rem] uppercase tracking-micro transition-colors ${active ? 'text-lilac' : 'text-muted hover:text-cream'}`} data-id="element-191" data-mp="2gjzronvx40v4">
                {discipline}
              </button>;
        })}
          <span className="ml-auto text-[0.65rem] uppercase tracking-micro text-muted" data-id="element-192" data-mp="pemx8gob7ww5">
            {visible.length}
          </span>
        </div>

        {visible.length === 0 ? <p className="mt-16 font-display text-xl uppercase text-muted" data-id="element-193" data-mp="yg35ahrnjmx7">
            Nothing in this category yet.
          </p> : <div className="mt-10 grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-194" data-mp="13dmkbjw6c3q7">
            {visible.map((project, index) => <Reveal key={project.slug} delay={index % 3 * 0.05} data-id="element-195" data-mp="1d622oibduubm" data-mpi={index}>
                <Link to={`/work/${project.slug}`} className="group block" data-id="element-196" data-mp="1h7dw6yxdnzp3">
                  <div className="overflow-hidden bg-cream/5" data-id="element-197" data-mp="1h5av9juosm5l">
                    {project.video ? <video src={project.video} poster={project.image || undefined} autoPlay loop muted playsInline aria-label={`${project.title} for ${project.client}`} className="h-56 w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.03] md:h-64" data-id="element-198" data-mp="1m4dx6vfdec9c" /> : <img src={project.image} alt={`${project.title} for ${project.client}`} className="h-56 w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.03] md:h-64" data-id="element-199" data-mp="3lcvrsjsggl28" />}
                  </div>
                  <div className="mt-3 flex items-baseline justify-between gap-4" data-id="element-200" data-mp="cywwlkdb53ps">
                    <h2 className="font-display text-lg uppercase leading-none transition-colors group-hover:text-lilac md:text-xl" data-id="element-201" data-mp="863ul49849he">
                      {project.title}
                    </h2>
                    <span className="shrink-0 text-[0.6rem] uppercase tracking-micro text-muted" data-id="element-202" data-mp="3swmvjw7cn7q8">
                      {project.year}
                    </span>
                  </div>
                  <p className="mt-1.5 text-[0.65rem] uppercase tracking-micro text-muted" data-id="element-203" data-mp="3jw6vyxtq8kqn">
                    {project.client} — {project.discipline}
                  </p>
                </Link>
              </Reveal>)}
          </div>}
      </div>

      <EndNote data-id="element-204" data-mp="1pk9fj6dbrmv" />
    </div>;
}